import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { GridName } from '../../../model/ag-grid-common-constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-checkbox-renderer',
  templateUrl: './checkbox-renderer.component.html',
  styleUrls: ['./checkbox-renderer.component.scss']
})
export class CheckboxRendererComponent implements OnInit, ICellRendererAngularComp {
  params: any
  isChecked:boolean = false;
  isDisabled:boolean = false;
  isReadonly:boolean = false;
  gridName = GridName
  subscription:Subscription
  constructor(public agGridService: AgGridService) { }

  ngOnInit(): void {
   this.subscription = this.agGridService.toggleHeaderCheckedValue.subscribe((params)=>{
      if(params?.value){
        this.updatecheckedValue()
      }
    })
  }
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params
    this.updatecheckedValue()
    if (this.params?.storageName === this.gridName.SEND_REQUEST)
      this.isDisabled = this.isReadonly = true
  }
  updatecheckedValue(){
    const rows = this.params?.api?.rowModel?.rowsToDisplay || [];
    var checkAllCheckedRows  =  rows.length > 0 && rows?.every((row) => row.data.partContact === true);
    if(checkAllCheckedRows){
      this.isChecked = true
    }else 
    this.isChecked = false
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false
  }
  onChange(event) {
    const isChecked = this.params.value = event;
    const allRows = this.params?.api?.rowModel?.rowsToDisplay;
    if (allRows) {
      allRows.forEach((row) => {
        row.setDataValue('partContact', isChecked);
      });
     this.agGridService.toggleCheckboxIcon.next({params:isChecked,value:true})
    }
    this.isChecked = isChecked;
  }
  ngOnDestroy(): void {
  this.subscription.unsubscribe();
}

}
